import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyDecimal]'
})
export class OnlyDecimalDirective {
  allowedKeys = ['Tab', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowDown', 'ArrowRight', 'ArrowUp', 'Insert'];

  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event'])
  onKeyPress(e: KeyboardEvent) {
    const input = this.el.nativeElement.value;
    const key = e.key;

    // Allow control/navigation keys
    if (this.allowedKeys.includes(key)) {
      return;
    }

    // Allow only digits and a single dot
    if (!/[\d.]/.test(key)) {
      e.preventDefault();
      return;
    }

    // Prevent more than one decimal point
    if (key === '.' && input.includes('.')) {
      e.preventDefault();
      return;
    }

    // Enforce 2 digits after decimal
    const [integer, decimal] = input.split('.');
    if (decimal !== undefined && input.includes('.') && this.getCursorPosition() > input.indexOf('.') && decimal.length >= 2) {
      e.preventDefault();
      return;
    }
  }

  private getCursorPosition(): number {
    const inputEl = this.el.nativeElement;
    return inputEl.selectionStart;
  }
}